<div *ngFor="let supplement of product?.supplements?.supplementItems || []">
  <lx-quote-product-label *ngIf="!!supplement.name" [productName]="supplement.name"></lx-quote-product-label>

  <lx-quote-product-description *ngIf="!!supplement.description" [productDescription]="[supplement.description]"></lx-quote-product-description>

  <lx-quote-price-item
    [hasProductPrice]="!supplement.priceOnRequest"
    [productPrice]="supplement.price | lxPrice : { currency: currency, minDecimalPlaces: decimalPlaces }"
  ></lx-quote-price-item>
</div>
